const Login = () => import('@/views/Login.vue');
const RedefinirSenha = () => import('@/views/RedefinirSenha.vue');
const EsqueceuSenha = () => import('@/views/EsqueceuSenha.vue');
const ConfirmacaoEmailEnviado = () => import('@/views/ConfirmacaoEmailEnviado.vue');

const routes = [
  {
    path: '/logar/:token',
    name: 'logar',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      public: true,
      disabledChatbox: true,
      title: 'Minhas compras',
    },
  },
  {
    path: '/redefinir-senha',
    name: 'redefinir-senha',
    component: RedefinirSenha,
    meta: {
      public: true,
      disabledChatbox: true,
      title: 'Redefinir Senha',
    },
  },
  {
    path: '/nao-sei-minha-senha',
    name: 'esqueceu-senha',
    component: EsqueceuSenha,
    meta: {
      public: true,
      disabledChatbox: true,
      title: 'Não sei minha senha',
    },
  },
  {
    path: '/confirmacao-email-enviado',
    name: 'confirmacao-email-enviado',
    component: ConfirmacaoEmailEnviado,
    meta: {
      public: true,
      disabledChatbox: true,
      title: 'E-mail redefinir senha enviado',
    },
  },
];

export default routes;
